/*
 * Тема на устройство, а не на человека: тёмная нужна планшету у линии
 * вечером, а не ПК того же кладовщика. Выбор в localStorage этого браузера,
 * без выбора тема системы. Атрибут data-theme на <html> читает tokens.css;
 * до первой отрисовки его ставит скрипт в index.html приложения, иначе
 * тёмная тема мигала бы светлой.
 */
export type ThemeChoice = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "wilco.theme";

export function readTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  try {
    if (choice === "system") localStorage.removeItem(THEME_STORAGE_KEY);
    else localStorage.setItem(THEME_STORAGE_KEY, choice);
  } catch {
    // Приватное окно без хранилища: тема живёт до перезагрузки.
  }
}

/** Тема, которая сейчас на экране. */
export function effectiveTheme(choice: ThemeChoice = readTheme()): "light" | "dark" {
  if (choice !== "system") return choice;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
